import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function Marquee() {
  const { t } = useTranslation();
  const ITEMS = t("marquee.items", { returnObjects: true });
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={`${key}-${item}`} className="flex items-center">
          <span className="font-display text-sm sm:text-base tracking-[0.3em] text-gray-500 px-8">{item}</span>
          <Sparkles size={13} className="text-[#F5CB5C]/60 shrink-0" />
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="editorial-marquee" className="relative border-y border-[#F5CB5C]/10 bg-[#0B0E14]/60 py-5 overflow-hidden">
      <div className="marquee-track flex w-max">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
